export const CARD_ERROR_SUPPORT_MESSAGE_UUID =
  '8cf90332-f7f3-489f-9b23-dbd77a71ccdd';
